// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"207":"__federation_expose_bootstrap","216":"vendors"}[chunkId] || chunkId) + "." + {"207":"fadd6482","216":"8bd8de2f","277":"bde7ca68","285":"06603cfa","528":"576e58f5"}[chunkId] + ".js";
};